import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { ChartContainer } from 'components/ChartContainer'
import { GlobalVariables } from 'Globals/GlobalVariables'

import presets from './presets.json'

type PresetKey = keyof typeof presets

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  if (properties) {
    if (properties.preset && Object.keys(presets).includes(properties.preset)) {
      properties = presets[properties.preset as PresetKey]
    }
  }

  return (
    <AppContainer $colorMode={colorMode}>
      <TextWidth>
        <ChartContainer
          title={
            properties?.title || 'Les communes les moins chères de Haute-Savoie'
          }
          toggleNameLeft={properties?.toggleNameLeft || 'Maisons'}
          toggleNameRight={properties?.toggleNameRight || 'Appartements'}
          dwChartIdLeft={properties?.dwChartIdLeft || 'pCplT'}
          dwChartIdRight={properties?.dwChartIdRight || 'yhTUj'}
        ></ChartContainer>
      </TextWidth>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
`
export default MainComponent
